// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"76d1c3aa","453":"a2610cf8"}[chunkId] + ".chunk.js";
};